import { BaseService } from "mrb/core";
import { DeviceMenuTypeApiRouteService } from "common/services";

class DeviceMenuTypeService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DeviceMenuTypeApiRouteService());
    }

    get(abortSignal = null) {
        const url = this.routeService.get();
        return this.apiClient.get(url, null, null, abortSignal);
    }
}

export default DeviceMenuTypeService;
